import { view } from './assets';
import Map from 'ol/Map';

let map = null;

export const iniMap = () => {
    map = new Map({
        target: 'map',
        layers: [],
        view: view,
        logo: false,
    });
}

export const getMap = () => {

    return map;
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/map/mapInstance.js